import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold mb-4" }, "Пользователи", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "pt-4" }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "fill-height",
            align: "center",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "64",
                    color: "primary"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: user.id,
              cols: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: "mb-4",
                  outlined: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(user.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, "Email: " + _toDisplayString(user.email), 1),
                        _createElementVNode("p", null, "Номер телефона: " + _toDisplayString(user.phone), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => (_ctx.showUserDetails(user)),
                          color: "primary",
                          dark: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" TODO-лист ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => (_ctx.openEditModal(user)),
                          color: "primary",
                          dark: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Редактировать данные ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showTodoModal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTodoModal) = $event)),
        "max-width": "600",
        scrollable: "",
        width: "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(" TODO-лист ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, { style: {"height":"300px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todos, (todo) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: todo.id,
                          class: "d-flex align-center flex-row"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: todo.completed,
                              "onUpdate:modelValue": ($event: any) => ((todo.completed) = $event),
                              class: _normalizeClass({ 'line-through': todo.completed }),
                              label: _ctx.truncateText(todo.title, 42)
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "label"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "blue darken-1",
                    variant: "text",
                    onClick: _ctx.closeTodoModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Закрыть ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "blue darken-1",
                    variant: "text",
                    onClick: _ctx.saveTodoList
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Сохранить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.editUser)
        ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 1,
            modelValue: _ctx.showEditModal,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showEditModal) = $event)),
            "max-width": "600"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Окно редактирования ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, {
                        ref: "editForm",
                        onSubmit: _ctx.saveUserData
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.editUser.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editUser.email) = $event)),
                            rules: _ctx.emailValidationRules,
                            label: "Email",
                            required: "",
                            "no-case-change": ""
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.editUser.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editUser.name) = $event)),
                            label: "Имя",
                            required: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.editUser.phone,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editUser.phone) = $event)),
                            rules: _ctx.phoneValidationRules,
                            label: "Номер телефона",
                            required: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _: 1
                      }, 8, ["onSubmit"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "blue darken-1",
                        variant: "text",
                        onClick: _ctx.cancelEdit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Закрыть ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        color: "blue",
                        onClick: _ctx.saveUserData,
                        dark: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Сохранить ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}